import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import Book from 'components/Icons/Book'
import { buildTranslate } from 'locales'
import './ThanxAIHelpLinks.scss'

const t = buildTranslate('components.ai.help_links')

export interface HelpLink {
  url: string
  text: string
}

export interface ThanxAIHelpLinksProps {
  helpLinks?: HelpLink[]
  helpLinkText?: string
  helpLinkTextAction?: HelpLink
}

const ThanxAIHelpLinks = ({
  helpLinks,
  helpLinkText,
  helpLinkTextAction,
}: ThanxAIHelpLinksProps) => {
  // Show component if we have either help links OR help link text/action
  if (!helpLinks?.length && !helpLinkText && !helpLinkTextAction) {
    return null
  }

  const renderHelpLink = (link: HelpLink, index: number) => (
    <a
      key={link.url || link.text || index}
      href={link.url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`${link.text}${t('aria_label_link_suffix')}`}
    >
      <Text.BodyText4 tag="p" color="belizeHole50">
        {link.text}
        <Book aria-hidden="true" />
      </Text.BodyText4>
    </a>
  )

  const helpLinkElements = helpLinks?.map(renderHelpLink)

  return (
    <div
      className="thanx-ai-help-links"
      role="complementary"
      aria-label={t('aria_label_resources')}
    >
      <Switch condition={Boolean(helpLinkText)}>
        <p className="thanx-ai-help-links__text">
          {helpLinkText}
          {helpLinkTextAction && (
            <>
              {' '}
              <a
                href={helpLinkTextAction.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`${helpLinkTextAction.text}${t(
                  'aria_label_link_suffix'
                )}`}
              >
                {helpLinkTextAction.text}
              </a>
            </>
          )}
        </p>
      </Switch>
      <Switch condition={Boolean(helpLinks && helpLinks.length > 0)}>
        <nav
          className="thanx-ai-help-links__links"
          aria-label={t('aria_label_documentation')}
        >
          {helpLinkElements}
        </nav>
      </Switch>
    </div>
  )
}

export default ThanxAIHelpLinks
